export enum LinkErrorType {
  DesoAlreadyLinked = 'DesoAlreadyLinked',
}
